import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  IconButton,
} from '@mui/material';
import { Visibility, Delete } from '@mui/icons-material';
import { File } from '../../types';
import { formatDate } from '../../lib/formatDate';

interface FileDialogProps {
  open: boolean;
  onClose: () => void;
  files: File[];
  onViewFile: (id: string) => void;
  onDeleteFile: (id: string) => void;
}

const FileDialog: React.FC<FileDialogProps> = ({
  open,
  onClose,
  files,
  onViewFile,
  onDeleteFile,
}) => {
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Files ({files.length})
      </DialogTitle>
      <DialogContent>
        {files.length === 0 ? (
          <Typography color="text.secondary" align="center" sx={{ py: 4 }}>
            No files uploaded
          </Typography>
        ) : (
          <List>
            {files.map((file, index) => (
              <ListItem key={file.id || index} divider>
                <ListItemText
                  primary={file.originalName}
                  secondary={`${formatFileSize(file.size)} • ${formatDate(file.createdAt)} • ${file.mimeType}`}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => onViewFile(file.id)}
                    sx={{ mr: 1 }}
                  >
                    <Visibility />
                  </IconButton>
                  <IconButton
                    edge="end"
                    onClick={() => onDeleteFile(file.id)}
                    color="error"
                  >
                    <Delete />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileDialog; 